import React from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";

const TopBar = () => {
  const logoutHanlder = () => {
    localStorage.removeItem("adminToken");
    window.location.reload();
  };
  return (
    <Navbar bg="light" expand="lg" className="shadow-sm px-3">
      <Container fluid>
        {/* Brand / Logo */}
        <Navbar.Brand href="#">E-Commerce Dashboard</Navbar.Brand>

        {/* Toggle button for small screens */}
        <Navbar.Toggle aria-controls="topbar-nav" />

        {/* Collapsible menu */}
        <Navbar.Collapse id="topbar-nav">
          <Nav className="ms-auto align-items-center">
            {/* Notifications */}
            <Nav.Link href="#">🔔 Notifications</Nav.Link>

            {/* Profile Dropdown */}
            <NavDropdown
              title={<span>👤 Profile</span>}
              id="profile-dropdown"
              align="end"
            >
              <NavDropdown.Item href="#/profile">My Account</NavDropdown.Item>
              <NavDropdown.Item href="#/settings">Settings</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item
                onClick={() => logoutHanlder()}
                className="text-danger"
              >
                🚪 Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default TopBar;
